import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../utils';
import { Typography } from './Typography';
import { useTicker } from '../lib/hooks';
import StartRecordingImage from '../assets/images/start-recording.svg';
import StartRecordingDisabledImage from '../assets/images/start-recording-disabled.svg';
import StopRecordingImage from '../assets/images/stop-recording.svg';
import { RECORDING_STATUS, CALL_STATUS } from '../Constants';

const inputColor = props => {
  if (props.Label) {
    return props.w01;
  }

  return colors.g04;
};

const InfoText = styled(Typography)`
  color: ${props => inputColor(props)};
  font-size: 12px;
  margin-bottom: 10px;
`;

const Wrapper = styled.div`
  opacity: ${props => (props.disabled ? 0.3 : 1)};
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 20px;
`;

const RecordWrapper = styled.div`
  align-items: center;
  cursor: ${props => (props.disabled ? 'progress' : 'pointer')};
  background-image: url(${StartRecordingImage});
  background-repeat: no-repeat;
  display: flex;
  height: 40px;
  justify-content: center;
  position: relative;
  transition: all 150ms;
  width: 40px;
`;

const Label = styled(Typography)`
  color: ${props => inputColor(props)};
  font-weight: bold;
  margin-top: 9px;
`;

function toTime(num) {
  let hours = Math.floor(num / 3600);
  let minutes = Math.floor((num - hours * 3600) / 60);
  let seconds = num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }

  return `${minutes}:${seconds}`;
}

const Recording = ({ onClick, call }) => {
  const time = useTicker({
    active: call.recordingStatus === RECORDING_STATUS.INPROGRESS,
    suspended: call.recordingStatus === RECORDING_STATUS.COMPLETED
  });
  const { recordingStatus, recordingStatusLoading, callStatus } = call;
  const disabled = recordingStatusLoading || callStatus !== CALL_STATUS.INPROGRESS.code;

  const recordingImage = () => {
    if (recordingStatus === RECORDING_STATUS.INPROGRESS) {
      return StopRecordingImage;
    }

    if (disabled) {
      return StartRecordingDisabledImage;
    }

    return StartRecordingImage;
  };

  const recordLabel = () => {
    if (recordingStatus === RECORDING_STATUS.INPROGRESS) {
      return 'Stop Recording';
    }

    if (recordingStatus > RECORDING_STATUS.INPROGRESS) {
      return 'Restart Recording';
    }

    return 'Start Recording';
  };

  const toggleRecording = async () => {
    if (disabled) {
      return;
    }
    onClick();
  };

  return (
    <Wrapper disabled={disabled}>
      {callStatus === CALL_STATUS.INITIATED.code && <InfoText>Initiating call...</InfoText>}
      {callStatus === CALL_STATUS.RINGING.code && <InfoText>Ringing...</InfoText>}
      {callStatus >= CALL_STATUS.INPROGRESS.code && <InfoText>{toTime(time)}</InfoText>}
      {recordingStatus <= RECORDING_STATUS.COMPLETED && (
        <>
          <RecordWrapper disabled={disabled} onClick={toggleRecording}>
            <img src={recordingImage()} alt={recordLabel()} />
          </RecordWrapper>
          <Label>{recordLabel()}</Label>
        </>
      )}
    </Wrapper>
  );
};

Recording.propTypes = {
  onClick: PropTypes.func.isRequired,
  call: PropTypes.shape({
    recordingStatus: PropTypes.number,
    callStatus: PropTypes.number,
    recordingStatusLoading: PropTypes.bool
  }).isRequired
};

export { Recording };
